import { useCallback, useEffect, useMemo } from 'react';
import I18n from 'I18n';
import { getRateLimitLocalStorage } from '../data/local-data/storeProvider';
export default function useFeedbackRateLimit(userId) {
  var _userId$toString;
  const storageKey = (_userId$toString = userId === null || userId === void 0 ? void 0 : userId.toString()) !== null && _userId$toString !== void 0 ? _userId$toString : 'no-user-id';
  const feedbackRateLimitLocalStorage = useMemo(() => getRateLimitLocalStorage(), []);
  const pruneAllRateLimit = useCallback(() => {
    var _feedbackRateLimitLoc;
    const currentMoment = I18n.moment();
    const targetRateLimit = JSON.parse((_feedbackRateLimitLoc = feedbackRateLimitLocalStorage.getItem(storageKey)) !== null && _feedbackRateLimitLoc !== void 0 ? _feedbackRateLimitLoc : '{}');
    const oneHourAgo = currentMoment.subtract(1, 'hour').unix();
    const allSubmissionsInAnHour = Object.keys(targetRateLimit).reduce((nrl, productUpdateId) => {
      var _targetRateLimit$prod;
      const productUpdateRateLimit = ((_targetRateLimit$prod = targetRateLimit[productUpdateId]) !== null && _targetRateLimit$prod !== void 0 ? _targetRateLimit$prod : []).filter(timestamp => timestamp > oneHourAgo);
      if (productUpdateRateLimit.length > 0) {
        nrl[productUpdateId] = productUpdateRateLimit;
      }
      return nrl;
    }, {});
    feedbackRateLimitLocalStorage.setItem(storageKey, JSON.stringify(allSubmissionsInAnHour));
    return allSubmissionsInAnHour;
  }, [feedbackRateLimitLocalStorage, storageKey]);
  useEffect(() => {
    if (feedbackRateLimitLocalStorage) {
      pruneAllRateLimit();
    }
  }, [feedbackRateLimitLocalStorage, pruneAllRateLimit]);
  const updateRateLimit = useCallback(productUpdateId => {
    var _allSubmissionsInAnHo;
    const allSubmissionsInAnHour = pruneAllRateLimit();
    const productUpdateIdStr = productUpdateId.toString();
    const now = I18n.moment();
    allSubmissionsInAnHour[productUpdateIdStr] = [...((_allSubmissionsInAnHo = allSubmissionsInAnHour[productUpdateIdStr]) !== null && _allSubmissionsInAnHo !== void 0 ? _allSubmissionsInAnHo : []), now.unix()];
    feedbackRateLimitLocalStorage.setItem(storageKey, JSON.stringify(allSubmissionsInAnHour));
  }, [feedbackRateLimitLocalStorage, storageKey, pruneAllRateLimit]);
  const checkIsAllowedToSubmitFeedback = useCallback(productUpdateId => {
    var _allSubmissionsInAnHo2;
    const allSubmissionsInAnHour = pruneAllRateLimit();
    const feedbackSubmissionTimestamps = [...((_allSubmissionsInAnHo2 = allSubmissionsInAnHour === null || allSubmissionsInAnHour === void 0 ? void 0 : allSubmissionsInAnHour[productUpdateId.toString()]) !== null && _allSubmissionsInAnHo2 !== void 0 ? _allSubmissionsInAnHo2 : [])].sort();
    const now = I18n.moment();
    const oneMinuteAgo = now.subtract(1, 'minute').unix();
    const submissionsInOneMinute = feedbackSubmissionTimestamps.filter(timestamp => timestamp > oneMinuteAgo);
    return submissionsInOneMinute.length < 3 && feedbackSubmissionTimestamps.length < 10;
  }, [pruneAllRateLimit]);
  return {
    updateRateLimit,
    checkIsAllowedToSubmitFeedback
  };
}